var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 40,
    viewBox: "0 0 96 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 20.5858L51.7929 16.2929C52.1834 15.9024 52.8166 15.9024 53.2071 16.2929C53.5976 16.6834 53.5976 17.3166 53.2071 17.7071L48.2071 22.7071C47.8166 23.0976 47.1834 23.0976 46.7929 22.7071L41.7929 17.7071C41.4024 17.3166 41.4024 16.6834 41.7929 16.2929C42.1834 15.9024 42.8166 15.9024 43.2071 16.2929L47.5 20.5858Z",
    fill: "#232D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionDropdown);
export default __webpack_public_path__ + "static/media/accordion-dropdown.528c5a467753206a43e137f5088f80d9.svg";
export { ForwardRef as ReactComponent };